
type Props = {
	searchType: string;
	billTo: string;
	searchBy: string;
	lookupValues: Record<string, string>;
}

export const MotorVehicleSearchDescription = ({
	searchType,
	billTo,
	searchBy,
	lookupValues
}: Props) => {
	return (
		<>
			<div className="item">
				<span><strong>Search type: </strong></span>
				<span>{searchType}</span>
			</div>
			<div className="item">
				<span><strong>Bill to: </strong></span>
				<span>{billTo}</span>
			</div>
			<div className="item">
				<span><strong>Search by: </strong></span>
				<span>{searchBy}</span>
			</div>
			{lookupValues && (
				<>
					{Object.entries(lookupValues).map(([key, value]) => (
						<div className="item" key={key}>
							<span><strong>{key}: </strong></span>
							<span>{value}</span>
						</div>
					))}
				</>
			)}
		</>
	)
}